import {ACTION_TYPES} from 'constants/ActionTypes';

export function setDataBreadCrumb(hasBreadcrumb, data) {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.SET_DATA_BREADCRUMB,
      hasBreadcrumb: hasBreadcrumb,
      data: data
    });
  };
}



// WEBPACK FOOTER //
// ./actions/breadcrumb.js